// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tabs{text-align:left;margin-top:30px}.tabs-title-button{background:0;border:0;outline:0;display:block}.tabs-content{padding-bottom:20px}", ""]);
// Exports
module.exports = exports;
